export default __webpack_public_path__ + "static/media/coupon.9e622cd8.svg";